import { render, staticRenderFns } from "./TeamBoard.vue?vue&type=template&id=3b385e9f&scoped=true&"
import script from "./TeamBoard.vue?vue&type=script&lang=ts&"
export * from "./TeamBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b385e9f",
  null
  
)

export default component.exports